import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";

const GALLERY_IMAGES = [
  {
    url: "https://static.prod-images.emergentagent.com/jobs/db1991f2-4272-42fb-8359-9b1347550866/images/82e111ec41de85b1c66ec7b1b037f3942cd1bf127e7b8a920edd9ef611428730.png",
    caption: "Fotografia cinematica de produto",
  },
  {
    url: "https://images.unsplash.com/photo-1649355422617-df9957b853a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxoaWdoJTIwZW5kJTIwZGFyayUyMHN0dWRpbyUyMHBvcnRyYWl0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzc1MDY1NDI4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Retrato em estudio escuro",
  },
  {
    url: "https://images.unsplash.com/photo-1544334845-576c8c7bb8ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZW5kJTIwZGFyayUyMHN0dWRpbyUyMHBvcnRyYWl0JTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzc1MDY1NDI4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Retrato editorial de moda",
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/db1991f2-4272-42fb-8359-9b1347550866/images/a7adb0d5d87f6ab09399dfaaf8a6f829d452e4b26a3a255ab8a856a72b0e9cf1.png",
    caption: "Retrato profissional com IA",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 lg:py-40 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-16 md:mb-20">
          <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[#00FF00] mb-4">
            // Galeria
          </p>
          <h2 className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-white">
            Resultados que <span className="text-[#00FF00]">impressionam</span>
          </h2>
          <p className="text-base md:text-lg text-white/50 mt-4 max-w-xl">
            Exemplos reais de imagens criadas usando a metodologia Advanse IA.
          </p>
        </div>

        {/* Carousel */}
        <div className="px-12">
          <Carousel
            opts={{ align: "start", loop: true }}
            data-testid="gallery-carousel"
          >
            <CarouselContent className="-ml-4">
              {GALLERY_IMAGES.map((img, index) => (
                <CarouselItem
                  key={index}
                  className="pl-4 md:basis-1/2 lg:basis-1/2"
                  data-testid={`gallery-slide-${index}`}
                >
                  <div className="relative group overflow-hidden border border-white/5 hover:border-[#00FF00]/20 transition-colors duration-500">
                    <img
                      src={img.url}
                      alt={img.caption}
                      className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <p className="font-['JetBrains_Mono'] text-xs text-white/70 tracking-wider">
                        {img.caption}
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious
              data-testid="gallery-prev-button"
              className="border-white/10 bg-black/60 hover:bg-[#00FF00] hover:text-black hover:border-[#00FF00] text-white transition-all duration-300"
            />
            <CarouselNext
              data-testid="gallery-next-button"
              className="border-white/10 bg-black/60 hover:bg-[#00FF00] hover:text-black hover:border-[#00FF00] text-white transition-all duration-300"
            />
          </Carousel>
        </div>
      </div>
    </section>
  );
}
